import React from "react";
import CheckOrderInputContainer from "@CheckOrder/components/MainSection/CheckOrderInputContainer";
import DropdownButton from "@Generic/buttons/DropdownButton";
import {DimensionOption, VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";
import IconLengthIndicator from "@Icons/vehicle/IconLengthIndicator";
import Translation from "@Translation/components/Translation";
import useGetSelectedVehicleHeightLabel
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleAdditionalHeight/hooks/useGetSelectedVehicleHeightLabel";

interface VehicleAdditionalHeightProps {
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }
    setHeight: (value: DimensionOption) => void,
    additionalHeight: DimensionOption | null,
}

function VehicleAdditionalHeight({activeOption, setHeight, additionalHeight}: VehicleAdditionalHeightProps) {
    const {getActiveLabel} = useGetSelectedVehicleHeightLabel(activeOption, additionalHeight)

    return (
        <CheckOrderInputContainer
            label={(<Translation translationKey="check_order.addons.JADL.vehicle.additional_height.title"/>)}
            className="vehicle__additional-height"
        >
            <Translation translationKey="check_order.addons.JADL.vehicle.additional_height.description"/>
            <DropdownButton
                label={getActiveLabel()}
                baseClass="gb--select"
                cssButtonClass="gb--select-dropdown"
            >
                {activeOption.activeGroup.heightOptions.map((option) => (
                    <button
                        type="button"
                        key={option.value}
                        value={option.value}
                        onClick={() => setHeight(option)}
                        className="gb--select__option full-width"
                    >
                        <IconLengthIndicator
                            orientation="vertical"
                        />
                        {option.label}
                    </button>
                ))}
            </DropdownButton>
        </CheckOrderInputContainer>
    );
}

export default VehicleAdditionalHeight